import { useMemo, useRef } from 'react';

export const useNonNegativeInteger = (num: number) => {
  const ref = useRef<number>(0);

  return useMemo(() => {
    const integer = Math.trunc(num);
    if (integer >= 0) {
      ref.current = integer;
    }
    return ref.current;
  }, [num]);
};
